import Vue from 'vue'

Vue.filter('whatsapp', (phonenumber: string | null): string => {
  if (!phonenumber) return ''
  return phonenumber.replace(/./, 'https://wa.me/0031')
})
